<template>
  <!-- <module-section :title="data.name"> -->
    <div class="container">
      
    </div>
  <!-- </module-section> -->
</template>

<script>
import ModuleSection from './ModuleSection.vue'

export default {
  components: {
    ModuleSection
  },
  props: {
    data: {
      type: Object,
      require: true
    }
  },
  methods: {
    type(target) {
      return typeof target;
    },
    handleToArticle(menu1Id, menu2Id) {
      this.$router.push({
        path: `/article/index?menu1Id=${ menu1Id }&menu2Id=${ menu2Id }`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
}

.item {
  display: flex;
  flex-direction: column;
  margin-right: 30px;
  flex: 1;
  padding: 30px;
  font-size: 18px;
  color: rgb(89, 89, 89);
  text-align: center;
  background-color: rgb(217, 217, 217);

  .img {
    flex: 1;
    img {
      margin-bottom: 24px;
      width: 100%;
    }
  }

  &:last-child {
    margin-right: 0;
  }

  .title {
    font-weight: 700;
    margin-bottom: 12px;
    font-size: 18px;
    text-align: center;
    cursor: pointer;
  }

  .intro {
    height: 120px;
  }

  .btn {
    text-align: left;
    font-weight: 700;
    font-size: 18px;
    color: #b1040e;
  }
}
</style>
